import React, { useState, useMemo } from 'react'
import util from 'meinian-package/src/utils/util'
import { useLocation } from 'react-router-dom'
import Icon from 'meinian-package/src/component/icon'
import Notice from 'component/notice'
import NavUser from 'component/navUser'
import DownloadCenter from 'component/download'
import Switcher from '../switcher'
import SearchModal from '../../searchModal/modal'
import css from './index.module.less'

export const MainHeaderLeft = () => {
  return <div className="meinian-header-left-search"><Search /></div>
}

export const MainHeaderRight = ({ style, children, hiddenSearch = false }) => {
  return <div className={css['meinian-header-right']} style={style}>
    {children}
    <div className="user-wrap">
      {
        hiddenSearch && <SearchBtn />
      }
      <Notice />
      <DownloadCenter style={{ marginLeft: 16 }} />
      <Switcher mainHeader={false} overlayStyle={{ width: '32px', height: '32px' }} style={{ padding: '0', marginLeft: '16px' }} />
      <NavUser />
    </div>
  </div>
}

export const SearchBtn = ({ inspirationId }) => {
  const [visible, setVisible] = useState(false)
  return <>
    <Icon type="m-sousuo" className="icon" onClick={() => setVisible(true)} />
    <SearchModal inspirationId={inspirationId} visible={visible} onCancel={() => setVisible(false)} />
  </>
}

export const Search = () => {
  const [searchVisible, setSearchVisible] = useState(false)
  const location = useLocation()
  const searchType = useMemo(() => (location.pathname.includes('home/sample') ? 'sample_clothing' : 'blog'), [location])
  return <span className={css['mn-global-search']}>
    <SearchModal type={searchType} visible={searchVisible} onCancel={() => setSearchVisible(false)} />
    <span
      className={css.search}
      onClick={() => {
        util.track('mn-header-link', {
          module1: '顶部导航',
          module2: '搜索框',
        })
        setSearchVisible(true)
      }}
    >
      <Icon type="m-sousuo" className={css.icon} />
      <span className={css.placeholder}>输入关键词搜索款式、灵感集</span>
    </span>
  </span>
}
